"use client";

import { ICartItemType } from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import {
  EventType,
  GtagActionField,
  IGTagUserData,
} from "../helpers/interfaces";
import useEventTrackers from "../useEventTrackers";
import { useAtom } from "jotai";
import { isSignedInAtom } from "@/hooks/authAtoms";
import { checkoutResultDataLayerAtom } from "@/hooks/checkoutResultAtom";
import { useGetProfileQuery } from "@/api/AppApi/services/auth";
import { toSHA256Hex } from "@/utils/functions/toSHA256Hex";

export const useTrackClickCheckoutEvents = () => {
  const [isSignedIn] = useAtom(isSignedInAtom);
  const getProfileData = useGetProfileQuery();
  const profileData = getProfileData?.data?.result;
  const { email, name, mobile_fields, id } = profileData ?? {};
  const profilePhone =
    mobile_fields?.dial_code_country.dial_code ??
    "" + (mobile_fields?.number ?? "");
  const { eventTrackers, GTagUserLoginEventTracher } = useEventTrackers();
  const [, setCheckoutResultDataLayer] = useAtom(checkoutResultDataLayerAtom);

  const trackEvents = (
    items: ICartItemType[],
    data: GtagActionField,
    shipping_tier: string,
    userdata: IGTagUserData,
  ) => {
    const userDataToTrack: IGTagUserData = isSignedIn
      ? {
          name,
          email,
          phone: profilePhone,
          email_hash: email ? toSHA256Hex(email) : "",
          phone_hash: profilePhone ? toSHA256Hex(profilePhone) : "",
          user_id: id,
        }
      : { ...userdata };
    setCheckoutResultDataLayer({
      isPurchaseEventTracked: false,
      items,
      data,
      shipping_tier,
      userdata: userDataToTrack,
    });
    eventTrackers(
      EventType.ADD_BILLING,
      items,
      {
        ...data,
      },
      { ...userDataToTrack },
    );

    eventTrackers(
      EventType.add_shipping_info,
      items,
      {
        ...data,
        shipping_tier,
      },
      { ...userDataToTrack },
    );

    GTagUserLoginEventTracher(isSignedIn, userDataToTrack);
  };

  return { trackEvents };
};
